
<template>
  <div class="main">
    <div class="container">
      <ol class="breadcrumb">
        <li><a href="/">{{ $t('components.HomeLayoutMain.71766206-0') }}</a></li>
        <li><a href="/personal-center">{{ $t('components.HomeLayoutMain.71766206-1') }}</a></li>
        <li class="active">{{ $t($route.meta.title) }}</li>
      </ol>
      <div class="centermain clearfix">
        <!--左侧 start -->
<!--        <div-->
<!--          class="leftmenudiv"-->
<!--          v-if="$route.path != '/home-service-center/quotedPriceAdd'"-->
<!--        >-->
<!--          <div class="userdiv">-->
<!--            <div class="userpic">-->
<!--              <img src="@/assets/images/userpic.png" />-->
<!--            </div>-->
<!--            <div class="uesrname">{{ userInfo.name }}</div>-->
<!--            <div class="account">用户名：{{ userInfo.phone }}</div>-->
<!--            <div class="company" v-if="userInfo.deptPname != null">-->
<!--              {{ userInfo.deptPname }}-->
<!--              <br />-->
<!--              {{ userInfo.deptName }}-->
<!--            </div>-->
<!--            <div class="company" v-else>-->
<!--              {{ userInfo.deptName }}-->
<!--            </div>-->
<!--            <div v-if="!isNew" class="account">注册状态：{{ userStatus }}</div>-->
<!--            <div>-->
<!--              &lt;!&ndash; <a href="javascript:void(0)" class="text_red changeSupplier"-->
<!--                >[切换]</a-->
<!--              > &ndash;&gt;-->
<!--              <el-select-->
<!--                v-if="!isNew"-->
<!--                v-model="supplierId"-->
<!--                placeholder="请选择供应商"-->
<!--                filterable-->
<!--                @change="supplierChange"-->
<!--                :disabled="$route.meta.isSupplierCodeRequired"-->
<!--              >-->
<!--                <el-option-->
<!--                  v-for="(item, index) in supplierArr"-->
<!--                  :key="index"-->
<!--                  :label="item.label"-->
<!--                  :value="item.value"-->
<!--                ></el-option>-->
<!--              </el-select>-->
<!--              <a v-if="userInfo.status == '10'" href="/supplier/step-" class="text_red">-->
<!--                [完善资料]-->
<!--              </a>-->
<!--              <a v-if="userInfo.isNotFirstContact && userInfo.isSupplier" href="javascript:void(0)" class="text_red">-->
<!--                [申请第一联系人]-->
<!--              </a>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div id="menu" class="leftmenu">-->
<!--            <el-menu-->
<!--              style="-->
<!--                margin-left: 5px;-->
<!--                margin-right: 5px;-->
<!--                background-color: #fafafa;-->
<!--                border-right: solid 0px;-->
<!--              "-->
<!--              default-active="2"-->
<!--              @open="handleOpen"-->
<!--              @close="handleClose"-->
<!--            >-->
<!--              <el-submenu-->
<!--                :index="menu.id"-->
<!--                v-for="menu in menus"-->
<!--                :key="menu.url"-->
<!--              >-->
<!--                <template slot="title">-->
<!--                  &lt;!&ndash; style="padding-left: 20px" &ndash;&gt;-->
<!--                  <i class="menu_icon" />-->
<!--                  <AppLink :to="menu.url">{{ menu.menuName }}</AppLink>-->
<!--                </template>-->
<!--                <AppLink-->
<!--                  :to="child.url"-->
<!--                  v-for="child in menu.children"-->
<!--                  :key="child.menuName"-->
<!--                  ><el-menu-item :index="child.id">{{-->
<!--                    child.menuName-->
<!--                  }}</el-menu-item></AppLink-->
<!--                >-->
<!--              </el-submenu>-->
<!--            </el-menu>-->
<!--          </div>-->
<!--        </div>-->
        <!--左侧 end -->
        <!-- 右侧 start -->
        <div
          id="home"
          class="rightmain"
          style="width: 1190px"
        >
          <!-- <keep-alive>
            <router-view v-if="$route.meta.keepAlive" />
          </keep-alive> -->
          <router-view v-if="updateRouterView" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppLink from "@/framework/layout/BaseLayoutSidebar/Link.vue";
import { mapState } from "vuex";
import { getRequest } from "@/framework/utils/request";
import { getDictList, querySupplierInfoById } from "@/api/index";

export default {
  components: { AppLink },
  computed: {
    ...mapState({
      showSettings: (state) => state.settings.showSettings,
      fixedHeader: (state) => state.settings.fixedHeader,
      userId: (state) => state.user.userId,
    }),
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("user")),
      menus: null,
      loginSupplier: {},
      supplierArr: [],
      supplierId: "",
      isNew: false,
      supplierStatusArr: [],
      userStatus: "",
      updateRouterView: true,
    };
  },
  watch: {
    supplierId: {
      handler(newVal, oldVal) { 
        if (oldVal) {
          this.updateRouterViewFunc()
        }
      },
      immediate: true,
    }
  },
  async created() {
    await this.getSupplierStatus();
    this.$eventBus.$on("hearSupplierchange", (val, arr) => {
      this.supplierChange(val, arr);
      this.supplierId = val;
    });
    this.isNew = this.$route.query.isNew;
    this.loginSupplier = localStorage.getItem("loginSupplier") == "{}"  ? {} : JSON.parse(localStorage.getItem("loginSupplier"));
    if (!this.isNew) {
      let str2 = Number(this.userInfo.id) * 2;
      let str5 = Number(this.userInfo.id) * 5;
      let str10 = Number(this.userInfo.id) * 10;
      let str = `${str2}+${str5}+${str10}+` + (Number(this.userInfo.id) + 12345);
      await this.switchCompany({ account: window.btoa(str) })
        .then((res) => {
          this.supplierArr = res.data.data.map((ele) => {
            return {
              value: ele.supplierId,
              label: ele.supplierName,
              supplierCode: ele.supplierCode,
            };
          });
          if (res.data.data && res.data.data.length) {
            let newSupplierId = localStorage.getItem("supplierId");
            let newSupplierCode = localStorage.getItem("supplierCode");
            let newSupplierSnCode = localStorage.getItem("supplierSnCode");
            this.supplierId = newSupplierId ? newSupplierId : res.data.data[0].supplierId;
            localStorage.setItem("supplierId", this.supplierId);
            localStorage.setItem("supplierCode", newSupplierCode ? newSupplierCode : res.data.data[0].supplierCode);
            localStorage.setItem("supplierSnCode", newSupplierSnCode ? newSupplierSnCode : res.data.data[0].supplierSnCode);
            this.supplierChange(this.supplierId);
            // this.getSupplierInfo(this.supplierId);
          }
        })
        .catch((error) => {
          // console.log("获取供应商数据失败:");
          // console.log(error);
        });
    }

    var supplierStatus = "0";
    if (this.$route.query.supplierStatus) {
      supplierStatus = this.$route.query.supplierStatus;
      let supplierType = this.loginSupplier.supplierType
        ? this.loginSupplier.supplierType
        : "0";

      let reqJson = {
        userTypeSet: [this.userInfo.userType],
        supplierType: supplierType,
        supplierStatus: supplierStatus,
      };

      this.getUserMenus(reqJson)
        .then((res) => {
          this.menus = res.data;
        })
        .catch((error) => {
          // console.log("获取菜单失败:");
          // console.log(error);
        });
    } else if (
      localStorage.getItem("menus") != "undefined" &&
      localStorage.getItem("menus") != undefined
    ) {
      this.menus = JSON.parse(localStorage.getItem("menus"));
    }
  },
  methods: {
    // 获取用户菜单
    getUserMenus(data) {
      let postReq = getRequest("common");
      return postReq({
        url: "/portal/supplierAfterLogin/getUserMenu",
        method: "post",
        data,
      });
    },
    // 获取供应商下拉框
    switchCompany(params) {
      let postReq = getRequest("common");
      return postReq({
        url: "/portal/supplierAfterLogin/switchCompanyByAccount",
        method: "get",
        params,
      });
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    supplierChange(supplierId, arr) {
      // console.log("supplierId", supplierId);
      localStorage.setItem("supplierId", supplierId);
      let data = arr;
      if (!data || !data.length) {
        data = this.supplierArr;
      }
      const selectData = data.filter((ele) => ele.value === supplierId);
      // console.log("supplierArr>>", this.supplierArr);
      // console.log("selectData>>", selectData);
      localStorage.setItem("supplierCode", selectData[0].supplierCode);
      // this.$eventBus.$emit("supplierchange", supplierId);
      // this.getSupplierInfo(supplierId); // 注释掉获取供应商信息-20260630
      // this.updateRouterViewFunc();
    },
    // 获取供应商状态
    async getSupplierStatus() {
      try {
        const { data } = await getDictList({ codelist: ["supplierStatus"] });
        const newArray = data.supplierStatus.map((item) => {
          const { dictItemName, dictItemCode } = item;
          return {
            label: dictItemName,
            value: dictItemCode,
          };
        });
        this.supplierStatusArr = newArray;
      } catch (err) {}
    },
    async getSupplierInfo(supplierId) {
      try {
      const res = await querySupplierInfoById({
        supplierId: supplierId,
      });
      if (res.code != 200) return;
      if (res.data) {
        // console.log('objobjobjobj2',res.data);
        localStorage.setItem('supplierCode2', res.data.supplierCode)
        const supplierStatus = res.data.supplierStatus;
        const selectData = this.supplierStatusArr.filter(
          (ele) => ele.value === supplierStatus
        );
        if (selectData.length) {
          this.userStatus = selectData[0].label;
        } else {
          this.userStatus = supplierStatus;
        }
      }
      } catch (err) {
        console.log('err', err);
      }
    },
    updateRouterViewFunc() {
      this.updateRouterView = false;
      this.$nextTick(() => {
        this.updateRouterView = true;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/config/styles/usercenter.scss";

.el-menu-item.is-active {
  color: black;
}
// .el-menu {
//     border-right: solid 0px #e6e6e6;
//     list-style: none;
//     position: relative;
//     margin: 0;
//     padding-left: 0;
//     background-color: #fafafa;
// }
.el-submenu__title {
  font-size: 14px;
  color: #0a0b0c;
  padding: 0 20px;
  cursor: pointer;
  -webkit-transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  box-sizing: border-box;
}
.menu_icon {
  display: inline-block;
  position: relative;
  margin-right: 10px;
  margin-left: 10px;
  width: 24px;
  height: 24px;
  background: url(~@/assets/images/icon_leftmenu.png) no-repeat;
}

.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  -webkit-transform: rotateZ(180deg);
  transform: rotateZ(180deg);
  color: black !important;
}
</style>
